import React, { FC, useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import Loader from '../../components/loader/Loader';
import UserStatus from '../../components/status-bar/UserStatus';
import TickerChart from '../../components/highcharts/TickerChart';
import { urls } from '../../services/Server';
import Auth from '../../auth/auth';
import './Home.css';
import { Ticker } from '../../interfaces/interfaces';

interface Props {
  pageName: string;
}

const Home: FC<Props> = ({ pageName }) => {
  const [tickerLoaded, setTickerLoaded] = useState<boolean>(false);
  const [ticker, setTicker] = useState<Ticker>();

  const loadTicker = () =>
    fetch(urls.ticker, {
      credentials: 'include'
    }).then(async response => {
      if (response.status !== 500) {
        const json = await response.json();
        setTicker(json);
        setTickerLoaded(true);
      }
    });

  useEffect(() => {
    loadTicker();
  }, []);

  const isLoggedIn = Auth.isLoggedIn();
  return (
    <Row>
      <div className="box">
        <div className="header">
          <h2> {pageName} </h2>
        </div>
        {isLoggedIn && <UserStatus />}
      </div>
      <div className="box">
        {tickerLoaded && ticker ? <TickerChart ticker={ticker} /> : <Loader />}
      </div>
      <div className="box">
        <div className="text-wrapper">
          <p>
            Hei og velkommen til $tockwatch. På denne siden kan du blant annet:
          </p>
          <ul>
            <li>Legge til en egen portefølje med aksjer og fond.</li>
            <li>
              Se statistikk og historikk over din porteføljes verdi og
              avkastning.{' '}
            </li>
            <li>
              Søke i alle fond og aksjer som er registrert hos Oslo Børs.{' '}
            </li>
            <li>
              Se detaljert info og grafisk historikk for spesifikke fond og
              aksjer.{' '}
            </li>
            <li>Se oversikt over dagens ticker på Oslo Børs.</li>
            <li>Se sanntidsinformasjon om aksje- og fondskurser.</li>
          </ul>
        </div>
      </div>

      <footer className="footer">
        <div className="container">
          <p className="text-muted">
            Les{' '}
            <a
              href="/privacy-policy"
              style={{ color: 'inherit', textDecoration: 'underline' }}
            >
              personvernerklæring
            </a>
          </p>
        </div>
      </footer>
    </Row>
  );
};

export default Home;
